import { render, staticRenderFns } from "./OutOfStockDialog.vue?vue&type=template&id=2a98464c&scoped=true&"
import script from "./OutOfStockDialog.vue?vue&type=script&lang=ts&"
export * from "./OutOfStockDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OutOfStockDialog.vue?vue&type=style&index=0&id=2a98464c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98464c",
  null
  
)

export default component.exports